<template>
  <div>
    <!-- Allow Edit Confirmation Modal -->
    <div class="modal fade" id="allowEditModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content m-t100">
          <div class="modal-header">
            <h3 class="modal-title">Allow Editing</h3>
            <button
              type="button"
              class="close"
              @click="closeEditModal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h3 style="font-size: 16px">
              Are you sure you want to allow editing? <br />
              The user will be able to modify the joining form.
            </h3>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-basic" @click="closeEditModal">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-cp ml-2"
              @click="confirmAllowEdit"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="d-flex justify-content-between" style="padding: 11px">
        <h4><strong>Joining Details</strong></h4>
        <div class="d-flex ms-auto">
          <button
            type="button"
            v-if="joiningData?.finalsubmit"
            class="btn btn-cp"
            @click="openEditModal"
            data-bs-toggle="tooltip"
            title="Allow editing joining form"
          >
            <i class="fa fa-lock" aria-hidden="true"></i>
          </button>

          <button class="btn btn-cp ml-2" @click="createZipWithDocuments">
            Download ZIP
          </button>
        </div>
      </div>
      <div class="col-sm-12 col-12 pr-sm-2 mb-3">
        <div class="my-2 text-center">
          <img
            v-if="joiningProfilePic !== null"
            :src="joiningProfilePic"
            alt="Profile Picture"
            class="mx-auto d-block rounded-circle"
            style="width: 200px; height: 200px; object-fit: cover"
          />
        </div>
      </div>
      <div class="well">
        <table
          class="table table-condensed table-compressed"
          aria-label="Personal Details"
          aria-hidden="true"
        >
          <tbody>
            <tr v-for="(questionPair, index) in questions" :key="index">
              <td class="col-md-3 px-2">
                <strong>{{ formatLabel(questionPair[0].label) }}</strong>
              </td>
              <td class="col-md-3 px-2">
                {{ flatData[questionPair[0].key]?.value || "-" }}
              </td>
              <td v-if="questionPair[1]" class="col-md-3 px-2">
                <strong>{{ formatLabel(questionPair[1].label) }}</strong>
              </td>
              <td v-if="questionPair[1]" class="col-md-3 px-2">
                {{ flatData[questionPair[1].key]?.value || "-" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="col-md-12">
      <h4><strong>Uploaded Documents</strong></h4>

      <div class="documents-container">
        <div
          v-for="(doc, index) in documents"
          :key="index"
          class="document-card"
        >
          <!-- isApplicant false as using this component on Admin side -->
          <document-preview
            :title="formatDocumentName(doc.label)"
            :id="doc.value"
            :documentUrl="doc.value"
            :isApplicant="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import DocumentPreview from "../../ApplicantMaster/_components/download-uploaded-document.vue";
import applicantAxios from "../../ApplicantMaster/_utils/axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      joiningProfilePic: null,
      data: null,
      questions: [],
    };
  },
  props: {
    joiningData: {
      type: Object,
      required: false,
    },
    slug: {
      type: String,
      required: false,
    },
  },
  components: {
    DocumentPreview,
  },
  watch: {
    joiningData: {
      async handler(newVal) {
        if (!newVal) return;
        this.data = newVal.joiningDetails.response;
        await this.$store.dispatch(
          "$_form_template/fetchEditorFormVersion",
          newVal.joiningDetails.formVersionId
        );
        this.fetchProfilePic();
      },
      immediate: true,
    },
    version: {
      handler(newVal) {
        const allQuestions = [];
        for (const section of newVal.form_json.sections) {
          for (const question of section.body) {
            if (question.type != "file") allQuestions.push(question);
          }
        }
        const pairedQuestions = [];
        for (let i = 0; i < allQuestions.length; i += 2) {
          pairedQuestions.push([allQuestions[i]]);
          if (allQuestions[i + 1])
            pairedQuestions[pairedQuestions.length - 1].push(
              allQuestions[i + 1]
            );
        }
        this.questions = pairedQuestions;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      version: "$_form_template/getEditorActiveFormVersion",
    }),
    flatData() {
      const result = {};
      for (const sectionId in this.data) {
        const section = this.data[sectionId];
        for (const questionId in section) {
          result[questionId] = section[questionId];
        }
      }
      return result;
    },
    documents() {
      const result = {};
      for (const sectionId in this.data) {
        const section = this.data[sectionId];
        for (const questionId in section) {
          result[questionId] = section[questionId];
        }
      }
      const allFiles = Object.values(result)
        .filter((item) => item.type == "file" && item.value)
        .map((item) => ({
          label: item.label,
          value: item.value,
          name: item.name,
        }));
      return allFiles;
    },
  },
  methods: {
    formatLabel(label) {
      if (!label) return "";
      let formatted = label.replace(/_/g, " ");
      formatted = formatted.replace(/([a-z])([A-Z])/g, "$1 $2");
      formatted = formatted.replace(/\b\w/g, (char) => char.toUpperCase());

      return formatted;
    },
    formatDocumentName(name) {
      if (!name || typeof name !== "string") return "";
      return name
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/([a-z])([A-Z])/g, "$1 $2") // Add a space before capital letters
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
    },
    async fetchProfilePic() {
      try {
        const fileId = this.documents?.find(
          (doc) => doc.label === "Passport Photo"
        )?.value;
        if (fileId) {
          const url = `/applicants/joining/documents/view/passportPhoto?FileId=${fileId}`;
          const response = await applicantAxios.get(url, {
            responseType: "blob",
          });

          const blobUrl = window.URL.createObjectURL(response.data);

          // Store the Blob URL in the component state
          this.joiningProfilePic = blobUrl;
        }
      } catch (error) {
        console.error("Error fetching the profile picture:", error);
      }
    },
    openEditModal() {
      $("#allowEditModal").modal("show");
    },
    closeEditModal() {
      $("#allowEditModal").modal("hide");
    },
    async confirmAllowEdit() {
      try {
        const res = await axios.post(
          `applicants/allow/edit-permissions/${this.slug}`
        );

        if (res.data.success) {
          this.joiningData.finalsubmit = false;
          this.$store.dispatch("openSnackbar", {
            type: "success",
            message: "Edit Permissions Granted!",
          });
        } else {
          this.$store.dispatch("openSnackbar", {
            type: "danger",
            message: res.data.message,
          });
        }
      } catch (error) {
        this.$store.dispatch("openSnackbar", {
          type: "danger",
          message: "Problem granting permission!",
        });
        console.error("API Error:", error);
      } finally {
        this.closeEditModal(); // Close modal after API call
      }
    },
    async fetchDocumentAsBlob(url) {
      try {
        const response = await axios.get(url, { responseType: "blob" });
        return new Blob([response.data], { type: "application/pdf" });
      } catch (error) {
        console.error("Error fetching document:", error);
        return null;
      }
    },
    async createZipWithDocuments() {
      if (!this.documents.length) {
        this.$store.dispatch("openSnackbar", {
          type: "danger",
          message: "No documents available to download.",
        });
        return;
      }
      const zip = new JSZip();
      const fullName = `${this.joiningData.first_name}_${this.joiningData.last_name}`;
      for (const doc of this.documents) {
        try {
          const fileBlob = await this.fetchDocumentAsBlob(
            `/applicants/joining/documents/view/${document.type}?FileId=${doc.value}`
          );
          if (fileBlob) {
            // Add the file to the ZIP
            if (doc.label === "Passport Photo") {
              zip.file(`${doc.name}.jpg`, fileBlob);
            } else {
              zip.file(`${doc.name}.pdf`, fileBlob);
            }
          }
        } catch (error) {
          console.error(`Failed to fetch ${doc.type}:`, error);
        }
      }
      // Generate and save the ZIP file
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `${fullName}_Documents.zip`);
    },
  },
  mounted() {
    this.fetchProfilePic();
  },
};
</script>
<style scoped>
.documents-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 10px;
}

.document-card {
  flex: 1 1 calc(25% - 16px);
  max-width: calc(25% - 16px);
  box-sizing: border-box;
}

/* Large screens (1024px to 1199px) */
@media (max-width: 1199px) {
  .document-card {
    flex: 1 1 calc(33.33% - 16px); /* 3 cards per row */
    max-width: calc(33.33% - 16px);
  }
}

/* Medium screens (768px to 1023px) */
@media (max-width: 1023px) {
  .document-card {
    flex: 1 1 calc(50% - 16px); /* 2 cards per row */
    max-width: calc(50% - 16px);
  }
}

/* Small screens (481px to 767px) */
@media (max-width: 767px) {
  .document-card {
    flex: 1 1 100%; /* 1 card per row */
    max-width: 100%;
  }
}

/* Mobile screens (480px and below) */
@media (max-width: 480px) {
  .document-card {
    flex: 1 1 100%; /* 1 card per row */
    max-width: 100%;
  }
}
</style>
